import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=e00e5fec&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=e00e5fec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e00e5fec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e00e5fec')) {
      api.createRecord('e00e5fec', component.options)
    } else {
      api.reload('e00e5fec', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=e00e5fec&scoped=true&", function () {
      api.rerender('e00e5fec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-26jogBczsfJJH/JS/comp/PopupBox.vue"
export default component.exports